module.exports = __webpack_public_path__ + "img/loginbg2.2c66bf9d.jpg";